// VFX: Heat Haze Distortion
// Category: overlays  ·  Tags: heat, haze, distortion, summer, atmospheric
// Shimmering heat haze — desert, summer, hot environments.
import {
  AbsoluteFill,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import React from "react";

export default function FxHeatHazeDistortionLoop() {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();
  const t = frame / durationInFrames;
  const bandCount = 24;
  return (
    <AbsoluteFill
      style={{
        background:
          "linear-gradient(180deg, #fbbf24 0%, #f97316 50%, #b45309 100%)",
        overflow: "hidden",
      }}
    >
      {/* sun haze */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(circle at 50% 30%, rgba(255,255,255,0.6) 0%, transparent 40%)",
          mixBlendMode: "screen",
        }}
      />
      {/* shimmering distortion bands */}
      {Array.from({ length: bandCount }).map((_, i) => {
        const y = (i / bandCount) * 100;
        const phase = frame * 0.08 + i * 0.6;
        const offset = Math.sin(phase) * 8;
        const opacity = 0.18 + Math.sin(phase * 0.5) * 0.08;
        return (
          <div
            key={i}
            style={{
              position: "absolute",
              top: `${y}%`,
              left: offset,
              right: -offset,
              height: 100 / bandCount + 0.5 + "%",
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.15) 0%, transparent 50%, rgba(0,0,0,0.1) 100%)",
              opacity,
              filter: "blur(2px)",
              mixBlendMode: "overlay",
            }}
          />
        );
      })}
      {/* horizon line shimmer */}
      <div
        style={{
          position: "absolute",
          top: "60%",
          left: 0,
          right: 0,
          height: 8,
          background:
            "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.5) 50%, transparent 100%)",
          filter: "blur(3px)",
          transform: `translateX(${Math.sin(t * Math.PI * 2) * 40}px)`,
        }}
      />
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
